import { Endereco } from '../shared/entity/Endereco';
import { GetManyParams, GetOneParams } from '../shared/types/TypeormTypes';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';
import api from './api';

const BASE_URL = '/endereco';

class enderecoApi {
  async getOne(query: GetOneParams<Endereco>) {
    try {
      let res = await this.getMany({ ...query, take: 1 });
      if (!res.length) {
        throw new Error('Produto não encontrado.');
      }
      return res[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getMany(query: GetManyParams<Endereco>) {
    try {
      let res = await api.post<Endereco[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async count(query: GetManyParams<Endereco>) {
    try {
      let res = await api.post<number>(BASE_URL + '/count', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async update(where: Partial<Endereco>, update: Partial<Endereco>) {
    try {
      let res = await api.put(BASE_URL, { update }, { params: where });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new enderecoApi();
